"use client"

import styled from "@emotion/styled"
import { Button, List, ListItem, MenuItem, Typography } from "@mui/material"
import { colors, mediaQueries, sizes } from "../../theme/theme"

/* MegaMenu */
export const MegaMenuDesktop = styled(List)``

/* MegaMenuItems */
export const StyledMenuItemWrapper = styled(ListItem)`
  display: flex;
  flex-direction: column;
  width: 100%;
  white-space: pre;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  ${mediaQueries.desktop} {
    padding-left: ${sizes.baseSingle};
    padding-right: ${sizes.baseSingle};
  }
`

export const StyledMegaMenuItem = styled(MenuItem)`
  display: flex;
  width: 100%;
  text-align: start;
  a {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 40px;
    align-items: center;
    text-decoration: none;
    padding-inline-start: 40px;
    padding-inline-end: 30px;
  }
  ${mediaQueries.mobile} {
    padding-top: 16px;
    padding-bottom: 16px;

    &:not(:last-child) {
      border-bottom: 1px solid ${colors.lightGray};
    }
  }
  ${mediaQueries.tablet} {
    padding-top: 16px;
    padding-bottom: 16px;
    &:not(:last-child) {
      border-bottom: 1px solid ${colors.lightGray};
    }
  }

  ${mediaQueries.desktopM} {
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: none !important;
  }
`
export const StyledButton = styled(Button)`
  padding: 0;
  ${mediaQueries.desktopM} {
    padding: 0;
    min-width: unset;
  }
  &:hover,
  &:focus,
  &:focus-visible,
  &.active {
    background-color: transparent;
    color: ${colors.red};
  }
`

export const StyledTypo = styled(Typography)`
  white-space: pre;
  font-size: 14px;
  &:hover,
  &:focus,
  &:focus-visible,
  &.active {
    color: ${colors.red};
  }
  ${mediaQueries.desktopXl} {
    font-size: 18px;
  }
`
export const StyledTypoInnerTitles = styled(StyledTypo)`
  padding-inline-start: 50px;
`
